export default __webpack_public_path__ + "static/media/fam8.bb462464.png";